import React, { useState, useEffect } from "react";
import CommonSection from "./../shared/CommonSection.jsx";
import { Container, Row, Col } from "reactstrap";
import { useLocation } from "react-router-dom";
import TourCard from "./../shared/TourCard.jsx";
import Newsletter from './../shared/Newsletter.jsx'

const SearchResultList = () => {
  const location = useLocation();
  const [tours, setTours] = useState([]);
  const [searchParams, setSearchParams] = useState(null);

  useEffect(() => {
    // Retrieve the filtered tours and search parameters from state
    if (location.state) {
      setTours(location.state.tours);
      setSearchParams(location.state.searchParams);
    }
  }, [location.state]);

  return (
    <>
      <CommonSection title={"Search Tours Locally"} />
      
      <section>
        <Container>
          <h3>Search Results for:</h3>
          <p>Location: {searchParams?.location}</p>
          <p>Distance: {searchParams?.distance} km</p>
          <p>Min Group Size: {searchParams?.maxGroupSize}</p>
        </Container>
      </section>

      <section>
        <Container>
          <Row>
            {tours.length === 0 ? (
              <h4 className="text-center">No tours found</h4>
            ) : (
              tours.map((tour) => (
                <Col lg="3" className="mb-4" key={tour._id}>
                  <TourCard tour={tour} />
                </Col>
              ))
            )}
          </Row>
        </Container>
      </section>

      <Newsletter />
    </>
  );
};

export default SearchResultList;









// import React, { useState } from "react";
// import CommonSection from "./../shared/CommonSection.jsx";
// import { Container, Row, Col } from "reactstrap";
// import { useLocation } from "react-router-dom";
// import TourCard from "./../shared/TourCard.jsx";
// import Newsletter from './../shared/Newsletter.jsx'

// const SearchResultList = () => {
//   const location = useLocation();

//   // Retrieve state if available, otherwise fallback to an empty object
//   const [data] = useState(location.state || { tours: [] });

//   // console.log(data);

//   return (
//     <>
//       <CommonSection title={"Tour Search Result"} />
//       <section>
//         <Container>
//           <Row>
//             {data.length === 0 ? (
//               <h4 className="text-center">No tour found</h4>
//             ) : (
//               data?.map((tour) => (
//                 <Col lg="3" className="mb-4" key={tour._id}>
//                   <TourCard tour={tour} />
//                 </Col>
//               ))
//             )}
//           </Row>
//         </Container>
//       </section>
//       <Newsletter />
//     </>
//   );
// };

// export default SearchResultList;










// import React, { useState } from "react";
// import CommonSection from "./../shared/CommonSection.jsx";
// import { Container, Row, Col } from "reactstrap";
// import { useLocation } from "react-router-dom";
// import TourCard from "./../shared/TourCard.jsx";
// import Newsletter from './../shared/Newsletter.jsx'

// const SearchResultList = () => {
//   const location = useLocation();

//   // Retrieve state if available, otherwise fallback to an empty object
//   const [data] = useState(location.state || { tours: [] });

//   // console.log(data);

//   return (
//     <>
//       <CommonSection title={"Tour Search Result"} />
//       <section>
//         <Container>
//           <Row>
//             {data.length === 0 ? (
//               <h4 className="text-center">No tour found</h4>
//             ) : (
//               data?.map((tour) => (
//                 <Col lg="3" className="mb-4" key={tour._id}>
//                   <TourCard tour={tour} />
//                 </Col>
//               ))
//             )}
//           </Row>
//         </Container>
//       </section>
//       <Newsletter />
//     </>
//   );
// };

// export default SearchResultList;
